export const english={
    home:{
        title:"FeedWell",
        link1:"Home",
        link2:"About",
        link3:"Review",
        btn1:"Login",
        btn2:"Go Home",
        heading1:"What is Malnutrition?",
        para1:"Malnutrition is the condition that develops when the body is deprived of vitamins, minerals and other nutrients it needs to maintain healthy tissues and organ function. Malnutrition occurs in people who are either undernourished or overnourished.",
        cardHeading1:"Causes",
        cardPara1:"The possible causes of malnutrition could be unsuitable dietary choices ,having a low income ,difficulty obtaining food ,various physical and mental health conditions",
        cardHeading2:"Symptoms",
        cardPara2:"weight loss, a lack of appetite or interest in food or drink, tiredness and irritability, an inability to concentrate, always feeling cold, depression, getting sick and taking longer to heal longer healing time for wounds",
        cardHeading3:"Treatment",
        cardPara3:"ongoing screening and monitoring making a dietary plan, which might include taking supplements treating specific symptoms,any infections that may be present checking for any mouth or swallowing problems suggesting alternative eating utensils",
        heading2:"People who helped us save",
        para2:"The internship scheme in Anganwadi is a program that allows students, volunteers, and individuals to participate in activities aimed at eradicating malnutrition in the community. Anganwadi centers are government-run centers that provide basic health care, nutrition, and education services to children under six years of age, pregnant women, and lactating mothers. The internship scheme in Anganwadi is designed to give individuals practical experience in running and managing nutrition programs, conducting community outreach, and implementing health and hygiene practices. By participating in this scheme, individuals can contribute to reducing malnutrition in the community and gain valuable skills and knowledge in the process. Through this scheme, Anganwadi centers are better equipped to provide holistic care and support to vulnerable populations, ensuring that children and mothers receive adequate nutrition and care for their healthy growth and development",
        heading3:"Reviews which helped us to save.",
        para3:"You can review the care centers where you have worked or are working, and also can provide suggestions which helps authorities to make better and informed desicions and also helps us to fight with malnutrition",
        bottomBtn:"Want to Add yours, Click Here",
        footerText:"FeedWell"
    },
    login:{
        heading1:"Login Now",
        placeholder1:"Email",
        placeholder2:"Password",
        btn1:"Continue",
        link1:"Don't have an account, Create one"
    },
    register:{
        heading1:"Register Yourself",
        placeholder1:"Name",
        placeholder2:"Email",
        placeholder3:"Password",
        btn1:"Register",
        link1:"Already have an account, Login"
    }
}